
<template lang="html">

	<vs-popup v-if="orderId != null" :active.sync = "$props.popupActive" style="z-index: 99999;"
	 :title="'Contrat n° ' + contractId + '\n' + (societyName ? societyName : '')+ ' : '  + $props.title">
		<div class="centerx" style="min-width: 800px; z-index:99;">

      <div class="container-fluid" >

        <div class="vx-row w-full" v-if="$acl.check('accountmanager')" style="justify-content: center;">
			<div class="vx-col">
                <vs-input
                    class="inputx w-full"
                    placeholder="Lien vers le document"
                    v-model="docLink"
                    :style="styleValidator('docLink')"
                    @change="validateOne(docLink, 'docLink')"
                />
                <vx-tooltip v-if="validators['docLink'] && validators['docLink'].errText !== ''" :text="errText('docLink')" class="ml-3">
                    <vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
                </vx-tooltip>
			</div>
			<div class="vx-col">
                <vs-select
                    v-model="docType"
                    class="select-medium mr-2"
                    autocomplete
                >
                <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.type_name"
                    v-for="(item, index) in typeList"
                    class="w-full"
                />
                </vs-select>
            </div>
            <div class="vx-col">
                <vs-input
                    class="inputx"
                    placeholder="Nom du document"
                    v-model="docName"
                    :style="styleValidator('docName')"
                    @change="validateOne(docName, 'docName')"
                />
                <vx-tooltip v-if="validators['docName'] && validators['docName'].errText !== ''" :text="errText('docName')" class="ml-3">
                    <vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
                </vx-tooltip>
			</div>
            <div class="vx-col">
                <vs-button
                    color="primary"
                    @click="validateAll()"
                >
                Ajouter
                </vs-button>
            </div>
        </div>
        <div v-if="allLinks.length > 0" class="w-full" style="z-index: 101 !important;">
            <ShareLinkTable
                v-if="refreshTable"
                :allLinks="allLinks"
                :apiUrl="apiUrl"
                @refresh-list="refreshList(order_id)"
		        @open-confirmation="confirmation(arguments)"
            />
        </div>
      </div>
  </div>
		</vs-popup>

<div v-else>
	<div class="centerx" style="min-width: 800px; z-index:99;">

      <div class="container-fluid" >

        <div class="vx-row w-full" v-if="$acl.check('accountmanager')" style="justify-content: center;">
			<div class="vx-col">
                <vs-input
                    class="inputx w-full"
                    placeholder="Lien vers le document"
                    v-model="docLink"
                    :style="styleValidator('docLink')"
                    @change="validateOne(docLink, 'docLink')"
                />
                <vx-tooltip v-if="validators['docLink'] && validators['docLink'].errText !== ''" :text="errText('docLink')" class="ml-3">
                    <vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
                </vx-tooltip>
			</div>
			<div class="vx-col">
                <vs-select
                    v-model="docType"
                    class="select-medium mr-2"
                    autocomplete
                >
                <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.type_name"
                    v-for="(item, index) in typeList"
                    class="w-full"
                />
                </vs-select>
            </div>
            <div class="vx-col">
                <vs-input
                    class="inputx"
                    placeholder="Nom du document"
                    v-model="docName"
                    :style="styleValidator('docName')"
                    @change="validateOne(docName, 'docName')"
                />
                <vx-tooltip v-if="validators['docName'] && validators['docName'].errText !== ''" :text="errText('docName')" class="ml-3">
                    <vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
                </vx-tooltip>
			</div>
            <div class="vx-col">
                <vs-button
                    color="primary"
                    @click="validateAll()"
                >
                Ajouter
                </vs-button>
            </div>
        </div>
        <div v-if="allLinks.length > 0" class="w-full" style="z-index: 101 !important;">
            <ShareLinkTable
                :task_id="task_id"
                v-if="refreshTable"
                :allLinks="allLinks"
                :apiUrl="apiUrl"
                @refresh-list="refreshList(task_id)"
		        @open-confirmation="confirmation(arguments)"
            />
        </div>
      </div>
  </div>
	</div>

</template>

<script>
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";

import store from "@/store/store";
import Validator from "@/entities/Validator";
import ShareLinkTable from "@/components/tables/ShareLinkTable";

export default {
	name: "ShareLinkPopup",
	components: {ShareLinkTable},
	props: {
		title: {
			default: "",
			type: String
		},
		apiUrl: String,
		society_id: Number,
		society_name: String,
		mission_id: Number,
		task_id: Number,
		contract_id: Number,
		order_id: Number,
		popupActive: Boolean
	},
	mixins: [dbFieldConvertor, utilsMixin],
	created(){
		this.getAllDocumentTypes();
		//console.log("order,", this.order_id);
		if(this.$props.order_id != null){
			this.$http.get(this.apiUrl + "orders/get/documentLink/"+this.orderId)
				.then(result => {
					//console.log("ShareLinkPopup created", result);
					this.allLinks = result.data;
				});
		}
		else{
			this.$http.get(this.apiUrl + "shared_document/list/task/" + this.task_id)
				.then(result => {
					//console.log("ShareLinkPopup created");
					this.allLinks = result.data;
				});
		}
	},
	data() {
		return {
			check: false,
			validators: {},
			docName: "",
			docLink: "",
			docType: 1,
			allLinks: [],
			contractId: this.$props.contract_id,
			societyName: this.$props.society_name,
			societyId: this.$props.society_id,
			orderId: this.$props.order_id,
			refreshTable: true
		};
	},
	computed: {
		typeList: () => {
			return store.state.docTypeList;
		},
		activeUser(){
			return VueCookies.get("userInfo");
		}
	},
	watch: {
		task_id: function(data){
			//console.log("watch task_id");
			this.refreshList(data);
		},
		order_id: function(data){
			//console.log("watch oreder_id");
			this.refreshList(data);
		},
	},
	methods: {
		confirmation(param){
			this.$emit("open-confirmation", param[0], param[1]);
		},
		getAllDocumentTypes(){
			store.dispatch("getAllDocumentTypes");
		},
		validateOne(val, name){
			let value = val;
			let constname = "";
			name == "docName" ? constname = "rnameConstraint" : constname = "linkConstraint";
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			this.validators[name].errText == "" && this.validators[name].valid == false ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators[name] && this.validators[name].valid == false){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators[name] && this.validators[name].valid == true){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "";
			}
		},
		validateAll() {
			this.check = true;
			let fields = ["docName", "docLink"];
			for(let i = 0; i < fields.length; i++){
				let name = "";
				let value = "";
				if(fields[i] == "docName"){
					name = "rnameConstraint";
					value = this.docName;
				}
				else{
					name = "linkConstraint";
					value = this.docLink;
				}
				this.validators[fields[i]] = new Validator({constraintName: name});
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" && this.validators[fields[i]].valid == false ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				this.validators[fields[i]].valid == false ? this.check = false : "";
				this.$forceUpdate();
			}
			if(this.check){
				this.$http.post(this.apiUrl + "shared_document/add", {
					filename: this.docName,
					link: this.docLink,
					society_id: this.societyId,
					contract_id: this.contractId,
					mission_id: this.$props.mission_id,
					task_id: this.$props.task_id,
					document_type_id: this.docType,
					user_id: this.activeUser.id,
					order_id: this.order_id
				}).then(() => {
					this.refreshList(this.task_id || this.order_id);
				});
			}
		},
		refreshList(id){
			this.refreshTable = false;
			let api;
			if(this.$props.order_id != null){
				api="shared_document/list/order_id/";
			}
			else{
				api="shared_document/list/task/";
				store.dispatch("getAllTasks");
			}
			this.$http.get(this.apiUrl +api + id)
				.then(result => {
					//console.log("ShareLinkPopup refresh");
					this.allLinks = result.data;
					this.refreshTable = true;
				});
			this.$emit("refresh-data");

		},
	}
};
</script>

<style scoped>
</style>
